import { render, staticRenderFns } from "./PizzaChart.vue?vue&type=template&id=a3e262aa&scoped=true&"
import script from "./PizzaChart.vue?vue&type=script&lang=js&"
export * from "./PizzaChart.vue?vue&type=script&lang=js&"
import style0 from "./PizzaChart.vue?vue&type=style&index=0&id=a3e262aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e262aa",
  null
  
)

export default component.exports